import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Capabilities from "./components/Capabilities";
import VideoSection from "./components/VideoSection";
import GeospatialSection from "./components/GeospatialSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Capabilities />
      <VideoSection title="See Our" subtitle="Capabilities in Action" />
      <GeospatialSection />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
